import type { DescriptionsProps } from 'antd'
import { Descriptions, Spin } from 'antd'
import './FacilityPopulationTabs.less'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import * as echarts from 'echarts'
import useStore from '@/hooks/useStore'

function FacilityPopulationTabs() {
  const facilityStore = useStore('facilityStore')
  const [tableItems, setTableItems] = useState<DescriptionsProps['items']>([])
  const [resultShow, setResultShow] = useState(true)
  const [Loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTableItems([])
    facilityStore.queryPopulationInfo().then((res: any) => {
      if (res.code === 200) {
        if (res.result.resultList.length > 0) {
          const data = res.result.resultList
          setTableItems([
            {
              key: '1',
              label: '평균나이',
              children: `${data[0].avgAge}세`,
              span: 4,
            },
            {
              key: '2',
              label: '노령화지수',
              children: data[0].agedChildIdx,
              span: 4,
            },
            {
              key: '3',
              label: '총가구',
              children: `${Number.parseInt(data[0].totFamily, 10).toLocaleString()}가구`,
              span: 4,
            },
            {
              key: '4',
              label: '총인구',
              children: `${Number.parseInt(data[0].totPpltn, 10).toLocaleString()}명`,
              span: 4,
            },
            {
              key: '5',
              label: '남자',
              children: `${Number.parseInt(data[0].mppl, 10).toLocaleString()}명`,
              span: 2,
            },
            {
              key: '6',
              label: '비율',
              children: `${data[0].mper}%`,
              span: 2,
            },
            {
              key: '7',
              label: '여자',
              children: `${Number.parseInt(data[0].fppl, 10).toLocaleString()}명`,
              span: 2,
            },
            {
              key: '8',
              label: '비율',
              children: `${data[0].fper}%`,
              span: 2,
            },
          ])
          initPie('tablePie1', data[0].residPpltnPer)
          initPie('tablePie2', data[0].jobPpltnPer)
          initPie('tablePie3', data[0].onePersonFamilyPer)
          initPie('tablePie4', data[0].sixtyFiveMorePpltnPer)
          initPie('tablePie5', data[0].twentyPpltnPer)
          setLoading(false)
        }
        else {
          setLoading(false)
          setResultShow(false)
        }
      }
      else {
        setLoading(false)
        setResultShow(false)
      }
    })
  }, [facilityStore.FacilityLeaseInfo])

  const initPie = (id: string, num: number) => {
    const myChart = echarts.init(document.getElementById(id))
    const percent = `${num}%`
    const option = {
      label: {
        formatter: `${percent}`,
      },
      series: [
        {
          name: '거주인구',
          type: 'pie',
          radius: ['50%', '90%'],
          label: {
            position: 'center',
          },
          color: ['#212528', '#f2f2f2'],
          data: [
            { value: num, name: '1' },
            { value: 100 - num, name: '거주인구' },
          ],
        },
      ],
    }
    myChart.setOption(option)
  }

  return (
        <div className={'FacilityPopulationTabs'}>
            {
                resultShow
                  ? (
                        <Spin tip="검색..." size="large" spinning={Loading}>
                            <div className={'tablePart'}>
                            <div className={'tbl-wrap-title'}>
                                    <strong>인구정보</strong>
                                    <a>시군구 기준</a>
                                    </div>
                                <Descriptions size={'small'} bordered items={tableItems}/>
                            </div>
                            <div className={'chartPart'}>
                                <ul className={'graph-list'}>
                                    <li className={'graph-item'}>
                                        <div className={'chart'} id={'tablePie1'} />
                                        <p>거주인구</p>
                                    </li>
                                    <li className={'graph-item'}>
                                        <div className={'chart'} id={'tablePie2'} />
                                        <p>직장인인구</p>
                                    </li>
                                    <li className={'graph-item'}>
                                        <div className={'chart'} id={'tablePie3'} />
                                        <p>1인가구</p>
                                    </li>
                                    <li className={'graph-item'}>
                                        <div className={'chart'} id={'tablePie4'} />
                                        <p>65세 이상</p>
                                    </li>
                                    <li className={'graph-item'}>
                                        <div className={'chart'} id={'tablePie5'} />
                                        <p>20대</p>
                                    </li>
                                </ul>
                            </div>
                        </Spin>
                    )
                  : (
                        <div className={'not-info'}>
                              결과가 없습니다.
                        </div>
                    )
            }

        </div>
  )
}
export default observer(FacilityPopulationTabs)
